import styled from "styled-components";
import theme from "../theme";

interface Props {
  color?: "default" | "alternate";
  inline?: boolean;
}

const BoxHighlight = styled.div<Props>`
  background: ${(props) =>
    props.color === "alternate" ? theme.colors.darkblue : theme.colors.blue};
  color: ${theme.colors.white};
  padding: ${theme.unit * 2}px ${theme.unit}px;
  margin-bottom: ${theme.unit * 2}px;

  margin-left: ${-1 * theme.unit}px;
  margin-right: ${-1 * theme.unit}px;

  p,
  h2 {
    color: ${theme.colors.white};
  }

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    border-radius: ${(props) => (props.inline ? 0 : 24)}px 0px 28px;
    margin-left: 0;
    margin-right: 0;
  }
`;

export default BoxHighlight;
